/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - European Union 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [sidebar.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 26.09.18 20:49
 */

import React, {useEffect, useState} from 'react';
import CalendarEntry from "./calendar-entry";
import usePeekEventSpaces from "../../components/hooks/use-peek-event-spaces";
import {asIsoDate, subtractDays, useLanguage} from "../../components/configuration/configuration";
import {SUCCESS_STATUS} from "../../actions";
import {Spinner} from "../../components/util/spinner";
import {useAuthorization} from "../../selectors";
import {ErrorBoundary} from "../../components/error-boundary/ErrorBoundary";
import SwiperContainer from "../../components/slider/swiper-container";
import {SwiperSlide} from "swiper/react";

const CalendarSliderTodayVertical = () => {
    const [todayEvents, setTodayEvents] = useState([]);
    const {peekEventSpacesFromDate, events, status} = usePeekEventSpaces();
    const {superuser} = useAuthorization();
    const Lang = useLanguage();

    useEffect(() => {
        // start a week ago - this date is already in the cache
        const fromIsoDate = asIsoDate(subtractDays(new Date(), 7));
        peekEventSpacesFromDate(superuser, fromIsoDate);
    }, []);

    useEffect(() => {
        if (events != null) {
            const todayEvents = resolveTodayEvents(events);
            setTodayEvents(todayEvents)
        }
    }, [events])

    const resolveTodayEvents = (events) => {
        return events.filter(event => event.today === true)
    }

    const renderTodayEvents = () => {
        return todayEvents.map((event, idx) => {
            return <SwiperSlide key={event.id}>
                <CalendarEntry peekspace={event}/>
            </SwiperSlide>
        })
    }

    const renderFallBack = () => {
        return <div className='mb-2'>
            {Lang.nav.sidebar.spaces.noneUpcoming}
            <p>(Something went wrong)</p>
        </div>;
    }

    if (status !== SUCCESS_STATUS) return <Spinner/>
    if (events.length === 0) return null;

    return <ErrorBoundary fallback={renderFallBack}>
        <div className='today-view-events-container mb-3'>
            <SwiperContainer
                direction={'vertical'}
                slidesPerView={"auto"}
                pagination={true}
                autoplay={false}
                scrollbar={false}>
                    {renderTodayEvents()}
            </SwiperContainer>
        </div>
    </ErrorBoundary>
}

export default CalendarSliderTodayVertical;